import React, { useEffect, useState } from 'react'
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import { ENDPOINT_ACCOUNT_BILLING_PORTAL } from '../Config';

function BillingPortal() {
    const axiosPrivate = useAxiosPrivate();

    const load = async () => {
        let portalURL = null;
        try {
            const response = await axiosPrivate.get(ENDPOINT_ACCOUNT_BILLING_PORTAL);
            if (response.status === 200) {
                portalURL = response.data;
            }
        } catch (error) {
            console.log(error);
        } finally {
            if (portalURL) {
                window.location.href = portalURL;
            } else {
                setTimeout(load, 3000);
            }
        }
    };

    useEffect(() => {
        load();
    }, []);

    return (
        <div className="d-flex flex-column justify-content-center align-items-center mt-5">
            <div className="card bg-light shadow-sm w-100" style={{ maxWidth: '30rem' }}>
                <div className="card-body d-flex justify-content-between align-items-center">
                    <h5 className="card-title text-info m-0">Redirecting to your Billing Portal...</h5>
                    <div className="spinner-border spinner-border-sm">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default BillingPortal
